import { useEffect, useState } from "react";
import Header from "./Header";
import { CoreContainer, Notification } from "./style";
import { Spinner, Table } from "reactstrap";
import { getAllOrgProjects } from "./service";
import { useNavigate } from "react-router-dom";

const Organizations = () => {
  const navigate = useNavigate();
  const [orgProjects, setOrgProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  useEffect(() => fetchAllOrgProjects(), []);

  const fetchAllOrgProjects = () => {
    setIsLoading(true);

    getAllOrgProjects()
      .then((res) => setOrgProjects(res))
      .catch((err) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: err.error });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Header nav={true} />
      {isNotificationVisible && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={() => setIsNotificationVisible(false)}
        >
          {notification.message}
        </Notification>
      )}
      {isLoading ? (
        <CoreContainer height="70vh">
          <Spinner size="sm" style={{ margin: "auto" }}>
            Loading...
          </Spinner>
        </CoreContainer>
      ) : (
        <div className="px-5 py-4">
          <Table bordered className="mt-4">
            <thead>
              <tr>
                <th>Org</th>
                <th>Draft</th>
                <th>Approval</th>
                <th>Payment Pending</th>
                <th>Ready to Place</th>
                <th>Placed</th>
                <th>Production</th>
                <th>Delivered</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody className="text-capitalize">
              {orgProjects.map((e, index) => (
                <tr key={index}>
                  <td>
                    {e.org_name}{" "}
                    <span className="text-secondary">(#{e.org_id})</span>
                  </td>
                  {[
                    "draft",
                    "finalised",
                    "payment_pending",
                    "ready_to_place",
                    "placed",
                    "production",
                    "delivered",
                    "total",
                  ].map((status) =>
                    // Check if status value is 0 and render an empty <td> or render the details if it's greater than 0
                    e[status] === 0 ? (
                      <td key={status}></td>
                    ) : (
                      <td
                        key={status}
                        className={`${e[status] === 0 ? "subtle" : ""}`}
                      >
                        {e[status] && (
                          <>
                            <a
                              className="pointer"
                              onClick={() =>
                                navigate(
                                  `/projects?org_id=${e.org_id}&status=${status}`
                                )
                              }
                            >
                              {e[status]}&nbsp;
                              {e[status] > 1 ? "Projects" : "Project"}
                            </a>
                            <span className="ms-2 text-muted">
                              ₹&nbsp;
                              {e[`${status}_value`] > 0
                                ? e[`${status}_value`].toLocaleString("en-IN")
                                : "N/A"}
                            </span>
                          </>
                        )}
                      </td>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

export default Organizations;
